/**
 * API Configuration - OnTimeLog 프로젝트 투입시간 관리 시스템
 * 
 * 상대 경로를 사용하여 Caddy 프록시를 통해 백엔드에 접근합니다.
 * 환경 변수 REACT_APP_API_URL이 설정되지 않으면 빈 문자열(상대 경로)을 사용합니다.
 * 
 * Note: axios interceptor는 App.js에서 설정됩니다.
 */

// 상대 경로 사용 (빈 문자열 = 현재 도메인)
// 환경 변수가 설정되어 있으면 해당 값 사용, 없으면 상대 경로 사용
const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const API_V1_BASE = `${API_BASE_URL}/api/v1`;

const apiConfig = {
  BASE: API_BASE_URL,
  BASE_URL: API_BASE_URL,
  V1: API_V1_BASE,
  
  // 투입시간 관련 API
  TIMELOGS: {
    BASE: `${API_V1_BASE}/timelogs`,
    MY: `${API_V1_BASE}/timelogs/my`,
    DAILY_SUMMARY: `${API_V1_BASE}/timelogs/daily-summary`,
    CREATE: `${API_V1_BASE}/timelogs`,
    UPDATE: (timelogId) => `${API_V1_BASE}/timelogs/${timelogId}`,
    DELETE: (timelogId) => `${API_V1_BASE}/timelogs/${timelogId}`,
  },
  
  // To-Do 리스트 API
  TODOS: {
    BASE: `${API_V1_BASE}/todos`,
    LIST: `${API_V1_BASE}/todos`,
    CREATE: `${API_V1_BASE}/todos`,
    UPDATE_STATUS: (todoId) => `${API_V1_BASE}/todos/${todoId}/status`,
    CREATE_LOG: (todoId) => `${API_V1_BASE}/todos/${todoId}/log`,
    DELETE: (todoId) => `${API_V1_BASE}/todos/${todoId}`,
  },
  
  // Task 관리 API - 제거됨: tasks 라우터가 unused_files로 이동됨 (work 테이블이 V3에서 제거되어 사용 불가)
  // 필요시 contract_work 테이블을 사용하는 새로운 API로 재구현 필요
  // TASKS: {
  //   SEARCH: `${API_V1_BASE}/tasks/search`,
  //   LIST: (contractId) => `${API_V1_BASE}/contracts/${contractId}/tasks`,
  //   CREATE: (contractId) => `${API_V1_BASE}/contracts/${contractId}/tasks`,
  //   UPDATE: (taskId) => `${API_V1_BASE}/tasks/${taskId}`,
  // },
  
  // 대시보드 API
  DASHBOARD: {
    CUSTOMER_HOURS: `${API_V1_BASE}/dashboard/customer-hours`,
    PROJECT_HOURS: `${API_V1_BASE}/dashboard/project-hours`,
    EMPLOYEE_HOURS: `${API_V1_BASE}/dashboard/employee-hours`,
    DELAY_STATS: `${API_V1_BASE}/dashboard/delay-stats`,
  },
  
  // 관리자 API
  ADMIN: {
    CUSTOMERS: {
      LIST: `${API_V1_BASE}/admin/customers`,
      CREATE: `${API_V1_BASE}/admin/customers`,
    },
    CONTRACTS: {
      LIST: `${API_V1_BASE}/admin/contracts`,
      CREATE: `${API_V1_BASE}/admin/contracts`,
    },
    EMPLOYEES: {
      LIST: `${API_V1_BASE}/admin/employees`,
      CREATE: `${API_V1_BASE}/admin/employees`,
    },
    TEMP_LOGS: {
      LIST: `${API_V1_BASE}/admin/temp-logs`,
      MAP: (templogId) => `${API_V1_BASE}/admin/temp-logs/${templogId}/map`,
    },
    NOTIFICATION_TIMES: {
      GET: `${API_V1_BASE}/admin/notification-times`,
      UPDATE: `${API_V1_BASE}/admin/notification-times`,
    },
  },
  
  // 프로젝트 API (ProjectContext 호환성)
  PROJECTS: {
    LIST: `${API_V1_BASE}/projects`,
    CREATE: `${API_V1_BASE}/projects`,
    DETAIL: (projectId) => `${API_V1_BASE}/projects/${projectId}`,
    DELETE: (projectId) => `${API_V1_BASE}/projects/${projectId}`,
  },
  
  // FCM 토큰 관리 API
  FCM: {
    SAVE_TOKEN: `${API_V1_BASE}/users/fcm-token`,
    DELETE_TOKEN: `${API_V1_BASE}/users/fcm-token`,
  },
};

export default apiConfig;
